"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var async_1 = __importDefault(require("../async"));
var extendHOC_1 = __importDefault(require("./extendHOC"));
var _a = async_1.default.actions, subscribeToUpdates = _a.subscribeToUpdates, unsubscribeFromUpdates = _a.unsubscribeFromUpdates;
/** @deprecated Use `useSubscription` instead */
var withSubscription = function (origin, method, variablesCreator, batch) {
    if (batch === void 0) { batch = true; }
    return function (UnwrappedComponent) {
        var Subscription = /** @class */ (function (_super) {
            __extends(Subscription, _super);
            function Subscription() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Subscription.prototype.componentDidMount = function () {
                this.store.dispatch(subscribeToUpdates(origin, method, variablesCreator(this.props), batch));
            };
            Subscription.prototype.componentDidUpdate = function (prevProps, prevState) {
                var prevOpts = variablesCreator(prevProps);
                var currOpts = variablesCreator(this.props);
                if (lodash_1.isEqual(prevOpts, currOpts))
                    return;
                // delete previous subscription
                this.store.dispatch(unsubscribeFromUpdates(origin, method, prevOpts, batch));
                // add new subscription
                this.store.dispatch(subscribeToUpdates(origin, method, currOpts, batch));
            };
            Subscription.prototype.componentWillUnmount = function () {
                this.store.dispatch(unsubscribeFromUpdates(origin, method, variablesCreator(this.props), batch));
            };
            Subscription.prototype.render = function () {
                return react_1.default.createElement(UnwrappedComponent, __assign({}, this.props));
            };
            return Subscription;
        }(react_1.default.Component));
        return extendHOC_1.default(UnwrappedComponent, Subscription, {
            withStore: true,
        });
    };
};
exports.default = withSubscription;
//# sourceMappingURL=withSubscription.js.map